export default Object.freeze({
  // SETTLEMENT_LIST_
  TITLE: '정산 현황 조회',
  CONFIRMED_HISTORY: '확정내역',
  UNCONFIRMED: '미확정내역',
  ESTIMATED_AMT: '정산예상금액',
  PERIOD_TYPE_MONTH: '월정산',
  PERIOD_TYPE_WEEK: '주정산',
  PERIOD_TYPE_DAY: '일정산',
  STATE_PENDING: '미확정',
  STATE_CONFIRM: '확정',
  GRID_TITLE: '정산예상금액 상세',
  EXCEL_PARTNER_BTN: '파트너별 다운로드',
  EXCEL_OPTION_BTN: '옵션별 다운로드',
  SALE_METHOD_PURCHASE: '사입',

  HEADER_DATE: '정산예정일',
  HEADER_PERIOD_TYPE: '정산유형',
  HEADER_STATE: '확정여부',
  HEADER_PERIOD: '집계기간',
  HEADER_PARTNER_NAME: '파트너',
  HEADER_PARTNER_TYPE: '국내/해외',
  HEADER_SALES_AMT: '판매액(A)',
  HEADER_COMMISSION_AMT: '판매수수료(B)',
  HEADER_DELIVERY_AMT: '배송비(C)',
  HEADER_PARTNER_DISCOUNT_AMT: '추가/상품/사은품할인파트너부담(D)',
  HEADER_DEDUCTED_AMT: '공제금액(E)',
  HEADER_AMT: '정산예상금액(F=A-B+C-D-E)',
  HEADER_BANK_NAME: '은행명',
  HEADER_TRADE_BANK_ACCOUNT: '계좌번호',
  HEADER_TRADE_BANK_DEPOSITOR_NAME: '예금주',
  HEADER_EXCEL_BTN: '상세보기',

  DEDUCTED_AMT_TITLE: '공제금액(E)',
  DEDUCTED_AMT_1: '<b>공제금액(E)</b> 항목 출력 값은 엑셀 파일 기준으로<br /><b>상품금액조정 파트너부담(E)+배송비금액조정 파트너부담(F)+쇼핑몰배송비(G)-환불보류 금액조정(H)</b> 입니다.',

  EXCEL_ORDER_CNT: '판매수량 합계',
  EXCEL_SALES_AMT: '판매금액 합계(A)',
  EXCEL_COMMISSION_AMT: '판매수수료 합계(B)',
  EXCEL_DELIVERY_AMT: '배송비(C)',
  EXCEL_SETTLEMENT_AMT: '정산예상금액(I=A-B+C-D-E-F-G+H)',
  EXCEL_BANK_NAME: '은행명',
  EXCEL_TRADE_BANK_ACCOUNT: '계좌번호',
  EXCEL_TRADE_BANK_DEPOSITOR_NAME: '예금주',
  EXCEL_BUSINESS_REGISTRATION_NO: '사업자등록번호',
  EXCEL_SETTLEMENT_MANAGER_NAME: '담당자',
  EXCEL_SETTLEMENT_MANAGER_EMAIL: '이메일',
  EXCEL_SETTLEMENT_MANAGER_PHONE_NO: '연락처',

  EXCEL_NAME: '정산현황'
});
